/* global starterTemplates:false, fetch:false */
import React, { useEffect, useState, useMemo } from 'react';
import { __ } from '@wordpress/i18n';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import throttle from 'lodash/throttle';
import { useStateValue } from '../../store/store';

import './styles.scss';

function SearchLocation(props) {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [value, setValue] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const loading = false && options.length === 0;
    const [placeDetails, dispatch] = useStateValue();
    const [{ currentIndex }] = useStateValue();
    const { sessionToken, onInputChange } = props;
    let defaultValue = {
        description: '',
        place_id: ''
    };

    if (placeDetails !== null) {
        const description = placeDetails.description;
        const place_id = placeDetails.place_id;

        if (typeof description !== 'undefined') {
            defaultValue = {
                description: description,
                place_id: place_id
            }
        }
    }

    const throttleFetch = useMemo(
        () =>
            throttle((request, callback) => {
                fetchPredictions(request, callback);
            }, 600),
        []
    );

    const fetchPredictions = async (args, callback) => {
        const response = await fetch(
            `${starterTemplates.api_domain}wp-json/starter-templates/v1/google-place-autocomplete?keyword=${args.input}&session_token=${sessionToken}`
        );
        const suggestions = await response.json();

        if (suggestions.success !== true) {
            return;
        }

        callback(suggestions.data.predictions);
    };

    useEffect(() => {
        if (inputValue === '') {
            setOptions([]);
            return;
        }

        // Set options to empty when new search is starting.
        setOptions([]);
        setValue({});

        throttleFetch({ input: inputValue }, (predictions) => {
            const locationOptions = [];
            predictions.forEach((prediction, key) => {
                locationOptions[key] = {};
                locationOptions[key].description = prediction.description;
                locationOptions[key].place_id = prediction.place_id;
            });

            setOptions(locationOptions);

            // If Predictions are available and also when value is not already set.
            if (
                locationOptions.length > 0 &&
                value &&
                Object.keys(value).length === 0
            ) {
                setOpen(true);
            }
        });
    }, [inputValue, fetch]);

    useEffect(() => {
        const description = placeDetails.description;
        const place_id = placeDetails.place_id;

        if (options.length === 0 && typeof description !== 'undefined') {
            const locationOptions = [];

            locationOptions[0] = {};
            locationOptions[0].description = description;
            locationOptions[0].place_id = place_id;

            setOptions(locationOptions);
        }

    }, [options]);

    useEffect(() => {
        if (value === null) {
            const description = placeDetails.description;
            const place_id = placeDetails.place_id;

            setValue({
                description: description,
                place_id: place_id,
            })
        }

    }, [value, options])

    return (
        <Autocomplete
            id="google-place-search"
            open={open}
            onOpen={() => {
                setOpen(false);
            }}
            onClose={() => {
                setOpen(false);
            }}
            onChange={(event, newValue) => {
                setValue(newValue);

                dispatch({
                    type: 'set',
                    placeDetails: newValue,
                });

                if ('function' === typeof onInputChange) {
                    onInputChange(event, newValue);
                }
            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            getOptionSelected={(option, optonValue) => {
                return option.place_id === optonValue.place_id ? true : false;
            }}
            defaultValue={defaultValue}
            getOptionLabel={(option) => {
                return option.description ? option.description : '';
            }}
            options={options}
            loading={loading}
            renderInput={(params) => (
                <>
                    <TextField
                        {...params}
                        label={__('Search Business', 'astra-sites')}
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    { loading ? (
                                        <CircularProgress
                                            color="inherit"
                                            size={20}
                                        />
                                    ) : null}
                                </>
                            ),
                        }}
                    />
                </>
            )}
        />
    );
}

export default SearchLocation;
